class ProfetNavigation {
	constructor() {
		this.toggleMobileMenu = document.querySelectorAll('.toggle-mobile-menu');
		this.mobileMenuWrapper = document.querySelector('.header-mobile-menu-wrapper');
		this.headerMobileLinks = document.querySelectorAll('.header-mobile-menu-wrapper a');
		this.headerDesktopLinks = document.querySelectorAll('.header-desktop-navigation-wrapper a');
		this.scrollPosition = 0;
		this.scrollBottom = 0;
		this.scrollPositionScreenCenter = 0;
		this.sections = []; // Sections to keep track of to set the .active class on a navigation link depeding on how far the user has scrolled on the page */
		this.sectionElements = document.querySelectorAll('[data-section-id]');
	}
	init() {
		this.handleClicks();
		this.setupSmoothScroll();
		if (this.sectionElements) {
			this.sectionElements.forEach((section) => {
				this.sections.push({
					id: section.getAttribute('id'),
					top: this.offset(section).top,
				});
			});
		}
		window.addEventListener('scroll', (event) => {
			this.scrollPosition = window.scrollY;
			this.scrollPositionScreenCenter = window.scrollY + window.innerHeight / 2;
			this.scrollBottom = window.scrollY + window.innerHeight;
			let activeSection = false;
			this.sections.forEach((section) => {
				if (section.top < this.scrollPositionScreenCenter) {
					activeSection = section.id;
				}
			});
			if (activeSection) {
				let link = document.querySelector('a[href="#' + activeSection + '"]');
				if (link && !link.classList.contains('active')) {
					this.clearActiveNavigationItems();
					link.classList.add('active');
				}
			} else {
				this.clearActiveNavigationItems();
			}
		});
	}
	offset(el) {
		var rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
	}
	handleClicks() {
		this.toggleMobileMenu.forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				document.querySelector('body').classList.toggle('mobile-menu-open');
			});
		});
		this.headerMobileLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				/* When a link is clicked in the mobile menu, hide the menu */
				document.querySelector('body').classList.remove('mobile-menu-open');
			});
		});
		this.headerDesktopLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				this.clearActiveNavigationItems();
				link.classList.add('active');
			});
		});
	}
	setupSmoothScroll() {
		document.querySelectorAll('.site-header ul a[href^="#"]').forEach((trigger) => {
			trigger.onclick = function(e) {
				e.preventDefault();
				let hash = this.getAttribute('href');
				let target = document.querySelector(hash);
				let headerOffset = 100;
				let elementPosition = target.offsetTop;
				let offsetPosition = elementPosition - headerOffset;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth',
				});
			};
		});
	}
	/* Remove the Active class from all navigation items */
	clearActiveNavigationItems() {
		this.headerDesktopLinks.forEach((link) => {
			link.classList.remove('active');
		});
	}
}
window.addEventListener('load', () => {
	window.profetNavigation = new ProfetNavigation();
	window.profetNavigation.init();
});
